import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import AccessControl from './sections/AccessControl'
import Header from './sections/Header'
import Intro from './sections/Intro'
import ItemBlock from './helpers/ItemBlock'
import LifeSketch from './sections/LifeSketch'
import OtherInformation from './sections/OtherInformation'
import Parents from './sections/Parents'
import SectionDivider from './helpers/SectionDivider'
import SectionHeading from './helpers/SectionHeading'
import SpousesAndChildren from './sections/SpousesAndChildren'
import Vitals from './sections/Vitals'
import OtherRelationships from './sections/OtherRelationships'

const personDataContainer = css`
  background-color: ${colors.gray00};
  border-radius: 4px 4px 4px 4px;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0px 1px 5px 0px,
    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px,
    rgba(0, 0, 0, 0.12) 0px 3px 1px -2px;
  height: 100%;
`
export default function Person({
  actionButtonOnClick,
  person,
  toggleShowItemHiddenDetails,
  toggleShowMoreLessLifeSketch,
  setLifeSketchExpandedHeight,
}) {
  const { t } = useTranslation()
  return (
    <div css={personDataContainer}>
      <Header isSurvivingPerson={person.isSurvivingPerson} />
      <Intro details={person.introDetails} />
      <SectionDivider />
      <SectionHeading heading={t('accessControl.label', 'Access Control')} />
      <AccessControl accessControl={person.accessControl} />
      <SectionDivider />
      {person.lifesketch.displayStatus !== 'REMOVE' && (
        <SectionHeading heading={t('person.fact.lifeSketch', 'Life Sketch')} />
      )}
      <ItemBlock
        selected={person.lifesketch.actionButtonType === 'UNDO'}
        displayStatus={person.lifesketch.displayStatus}
        isSurvivingPerson={person.isSurvivingPerson}
      >
        <LifeSketch
          actionButtonOnClick={actionButtonOnClick}
          person={person}
          toggleShowItemHiddenDetails={toggleShowItemHiddenDetails}
          toggleShowMoreLessLifeSketch={toggleShowMoreLessLifeSketch}
          setLifeSketchExpandedHeight={setLifeSketchExpandedHeight}
        />
      </ItemBlock>
      <SectionDivider />
      <SectionHeading heading={t('tools.adminMerge.headings.vitals', 'Vitals')} />
      <Vitals
        person={person}
        actionButtonOnClick={actionButtonOnClick}
        toggleShowItemHiddenDetails={toggleShowItemHiddenDetails}
      />
      <SectionDivider />
      <SectionHeading heading={t('tools.adminMerge.headings.otherInformation', 'Other Information')} />
      <OtherInformation
        person={person}
        actionButtonOnClick={actionButtonOnClick}
        toggleShowItemHiddenDetails={toggleShowItemHiddenDetails}
      />
      <SectionDivider />
      <SpousesAndChildren person={person} actionButtonOnClick={actionButtonOnClick} />
      <Parents person={person} actionButtonOnClick={actionButtonOnClick} />
      <OtherRelationships person={person} actionButtonOnClick={actionButtonOnClick} />
    </div>
  )
}
